/**
 * Maps n from range [start1, stop1] to range [start2, stop2]
 * e.g. map(0.25, 0, 1, 0, 100) => 25
 */
export function map(
  n: number,
  start1: number,
  stop1: number,
  start2: number,
  stop2: number
): number {
  return ((n - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
}
